module.exports = __webpack_public_path__ + "img/FAQ.24f1faca.png";